export type Breadcrumb = {
  id: string
  name: string
  pathname?: string
}

export enum CesTestType {
  stcw = 1,
  detailed = 3,
  companySpecific = 4,
}

export enum FeedbackFormQuestionType {
  Undefined,
  FreeText,
  YesNo,
  MultipleChoice,
}

export enum RedirectRoute {
  Home = 'Home_Ocean',
  Profile = 'Profile_Ocean',
  Library = 'Library_Ocean',
  Requirements = 'RequiredTasks_Ocean',
  Search = 'Search_Ocean',
  MyEvents = 'MyEvents_Ocean',
  EventLibrary = 'EventLibrary_Ocean',
  InstructorLed = 'InstructorLed_Ocean',
  StudentLed = 'StudentLed_Ocean',
  VirtualClassroomCreateEvent = 'VirtualClassroomCreateEvent_Ocean',
  VirtualClassroomManageEvents = 'VirtualClassroomManageEvents_Ocean',
  ProgramBuilder = 'ProgramBuilder_Ocean',
  Dashboard = 'OtgDashboard_Ocean',
}

export enum LegacyMenuRedirectRoute {
  Help = 'Ocean_Help',
  MyEvents = 'OCEAN_MY_EVENTS',
  EventLibrary = 'OCEAN_EVENT_LIBRARY',
  InstructorLed = 'OCEAN_INSTRUCTOR_LED',
  StudentLed = 'OCEAN_STUDENT_LED',
  Home = 'OCEAN_HOME',
  VirtualClassroom = 'OCEAN_VIRTUAL_CLASSROOM',
  SimulatorTraining = 'OCEAN_SIMULATOR_TRAINING',
  VirtualTrainerPlugin = 'VirtualTrainerPlugin',
}

export enum LegacyMenuVirtualTrainerModuleName {
  AddVirtualEvent = 'AddVirtualEvent',
  ViewVirtualEvents = 'ViewVirtualEvents',
}

export enum LoginType {
  Regular,
  Sta,
  MobileNative,
  Proxy,
  Sso,
}

export type ModuleLocalization = {
  namespace: string
  en: Record<string, any>
}
